import "../../../assets/scss/billings-style.scss";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../store/hooks";
import { CreditDisplayTables } from "../../components/CreditDisplayTables";
import { DepositBalanceBtn } from "../../components/DepositBalanceBtn";

export const Billings = () => {
  const { t } = useTranslation();
  const credit = useAppSelector((state: any) => state.user.credit);

  return (
    <>
      <div className="billings-title-wrapper">
        <div className="title">
          <h2>{t("Billings")}</h2>
          <span>{t("billings descriptions")}</span>
        </div>
        <div className="billings-current-balance">
          <div className="info">
            <span>{t("Current Credits")}</span>
            <h2>
              {credit} {t("Credit")}
            </h2>
            <DepositBalanceBtn />
          </div>
        </div>
      </div>
      <div className="billings-title-wrapper">
        <div className="title">
          <h2>{t("Billing History")}</h2>
        </div>
      </div>
      <CreditDisplayTables />
    </>
  );
};
